// Intro-limit helpers. The number of intros an topic is actually allowed to send is
// the smaller of the manager's per-topic `introCountLimit` and the global, permanent
// `introCountMax` config value (either may be unset = "no limit"). Zero is a valid
// ceiling meaning "no further intros" — an emergency kill switch.

// Returns the smaller of the two ceilings, ignoring unset or negative values. A limit of
// 0 is valid (blocks all intros) and wins the min. null means "no limit".
export function effectiveIntroLimit(
  perTopic?: number | null,
  introCountMax?: number | null
): number | null {
  const candidates = [perTopic, introCountMax].filter(
    (v): v is number => typeof v === 'number' && v >= 0
  );
  return candidates.length === 0 ? null : Math.min(...candidates);
}

// True when the topic has reached (or exceeded) its effective intro limit.
export function introLimitReached(
  introCount: number | null | undefined,
  perTopic?: number | null,
  introCountMax?: number | null
): boolean {
  const eff = effectiveIntroLimit(perTopic, introCountMax);
  return eff != null && (introCount ?? 0) >= eff;
}

// Notice shown in the topic form when a global cap is configured, explaining that the
// smaller of the global cap and the per-topic limit applies.
export function globalIntroCapNotice(max: number): string {
  return `All topics currently limited to ${max} intros by Snowball. We'll use whichever limit is smaller for this topic.`;
}
